import React, { PropsWithChildren } from "react";
import { PageTitleSection } from "./PageTitleSection";

export const DefaultPageTitleSection: React.FC<PropsWithChildren> = ({
  children,
}: PropsWithChildren) => {
  if (typeof children == "string") {
    return <PageTitleSection name={children} />;
  } else {
    return <>{children}</>;
  }
};
